import { PublicAmorgUser } from '.';

export type WorkgroupType =
    'committee' |
    'workgroup';

export class Workgroup{

    constructor(
        public id:string,
        public parentWorkgroupId:string | null,
        public name:string,
        public type:WorkgroupType,
        public members:PublicAmorgUser[]
    ){}
} 